import { CommonModule } from '@angular/common';
import { Component, Inject, OnDestroy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { Subscription, firstValueFrom } from 'rxjs';
import { ModelRole } from '../../models/model-role';
import { snack, snackErr } from '../../modules/snack.module';
import { ModelRoleService } from '../model-role/model-role.service';
import { t } from '../translate/translate.function';
import { TranslateModule } from '../translate/translate.module';

export interface SelectTenantInvolvedDialogData {
  tenant: ModelRole;
  agreementId: number;
}

@Component({
  selector: 'apex-select-tenant-involved-dialog',
  templateUrl: './select-tenant-involved-dialog.component.html',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatDialogModule,
    MatButton,
    MatFormFieldModule,
    MatDatepickerModule,
    MatIcon,
    MatInput,
    TranslateModule,
  ],
})
export class SelectTenantInvolvedDialogComponent implements OnDestroy {
  modelRole: ModelRole;
  tenantName: string;

  private subscription = new Subscription();

  constructor(
    public dialogRef: MatDialogRef<SelectTenantInvolvedDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SelectTenantInvolvedDialogData,
    private modelRoleService: ModelRoleService,
  ) {
    this.tenantName = data.tenant.CRMUser?.name || data.tenant.User?.name || 'Unknown';

    this.modelRole = new ModelRole({
      model: 'agreement',
      modelId: String(data.agreementId),
      role: 'involved',
      CRMUserId: data.tenant.CRMUserId,
      UserId: data.tenant.UserId,
      from: new Date(),
      to: null,
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  async save(): Promise<void> {
    if (this.modelRole.from) {
      try {
        const savedRole = await firstValueFrom(this.modelRoleService.saveRoleForModel(this.modelRole));

        snack(t('Tenant added as involved'));
        this.dialogRef.close(savedRole);
      } catch (error) {
        console.error('Error adding tenant as involved:', error);
        snackErr(t('Could not add tenant'), error);
      }
    }
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
